import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import caciLogo from '../images/cacilogo.png';
import { useNavigate } from 'react-router-dom';
import './Menu.css';

export default function Menu() {
  const navigate = useNavigate();
  const [collapseActive, setCollapseActive] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {

    const storedActiveLinkIndex = localStorage.getItem('activeLinkIndex');

  // Apply the 'active' class to the corresponding link and underline elements
  for (let i = 0; i < 8; i++) {
    const linkElement = document.getElementsByClassName('navBar-link-inner')[i];
    const underlineElement = document.getElementsByClassName('underline')[i];
    
    if (i === parseInt(storedActiveLinkIndex)) {
      linkElement.classList.add('active');
      underlineElement.classList.add('active');
    } else {
      linkElement.classList.remove('active');
      underlineElement.classList.remove('active');
    }
  }
    // Store the current scroll position
    const handleCollapse = () => {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
      {
      if (collapseActive) 
      {
        document.getElementsByClassName('bodyOverlay')[0].style.display='block';
        setScrollPosition(window.scrollY);

        if (window.innerWidth < 992) 
        {
          document.documentElement.style.overflowY = 'hidden';
          document.body.style.overflowY = 'hidden';
        }
        if (window.innerWidth < 992) 
        {
          document.body.addEventListener('touchmove', preventTouchMove, {
            passive: false,
          });
        }
      } 
      else 
      {
        document.getElementsByClassName('bodyOverlay')[0].style.display='none';
        //window.scrollTo(0, scrollPosition);

        if (window.innerWidth < 992) 
        {
          document.documentElement.style.overflowY = 'auto';
          document.body.style.overflowY = 'auto';
          document.body.style.height = 'auto';
        }
        if (window.innerWidth < 992) 
        {
          document.body.removeEventListener('touchmove', preventTouchMove);
        }
      }
    }
    };

    handleCollapse();

    // Cleanup function to remove touchmove event listener
    return () => {
      if (window.innerWidth < 992) {
        document.body.removeEventListener('touchmove', preventTouchMove);
      }
    };
  }, [collapseActive, scrollPosition]);

  // Function to prevent touchmove event
  const preventTouchMove = (event) => {
    event.preventDefault();
  };

  function removeShow() {
    if (window.innerWidth < 992) {
      document.getElementById('navbarToggler').click();
      window.scrollTo({ top: -300, left: 0, behavior: 'instant' });
    }
  }

  return (
    <Navbar collapseOnSelect expand="lg" variant="custom" fixed="top">
      <Container fluid>
        <span className="navbarTitle">
          <span style={{letterSpacing: '0.1rem'}}>FY 2025 CORPORATE <br/>RESPONSIBILITY REPORT</span>
        </span>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" id="navbarToggler" onClick={() => setCollapseActive(!collapseActive)}>
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav" className={collapseActive ? 'active' : ''}>
          <div className='backgroundFilter'>
          </div>
          <div className="navBar-link navImg">
            <div className="navBar-link-innerLogo">
              <img
                className="menuLogo"
                src={caciLogo}
                width="100%"
                alt="CACI Logo"
                onClick={() => window.open('https://www.caci.com', '_blank')}
              />
            </div>
          </div>
          <div
            className="navBar-link"
            onClick={() => {
              removeShow();
              navigate('/');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
              	    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
              	    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[0].classList.add('active');
              document.getElementsByClassName('underline')[0].classList.add('active');
            }}
            onTouchStart={() =>
              document.getElementsByClassName('underline')[0].classList.add('touchActive')
            }
            onTouchEnd={() =>
              document.getElementsByClassName('underline')[0].classList.remove('touchActive')
            }
          >
            <div className="navBar-link-inner active">
              <span className="underline active">Home</span>
            </div>
          </div>
          <div
            className="navBar-link"
            onClick={() => {
              removeShow();
              navigate('/president-and-ceo-message');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
              	    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
              	    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[1].classList.add('active');
              document.getElementsByClassName('underline')[1].classList.add('active');
            }}
            onTouchStart={() =>
              document.getElementsByClassName('underline')[1].classList.add('touchActive')
            }
            onTouchEnd={() =>
              document.getElementsByClassName('underline')[1].classList.remove('touchActive')
            }
          >
            <div className="navBar-link-inner">
              <span className="underline">President and<br/> CEO Message</span>
            </div>
          </div>
          <div
            className="navBar-link"
            onClick={() => {
              removeShow();
              navigate('/fy2025-highlights');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[2].classList.add('active');
              document.getElementsByClassName('underline')[2].classList.add('active');
            }}
            onTouchStart={() =>
              document.getElementsByClassName('underline')[2].classList.add('touchActive')
            }
            onTouchEnd={() =>
              document.getElementsByClassName('underline')[2].classList.remove('touchActive')
            }
          >
            <div className="navBar-link-inner">
              <span className="underline">Highlights</span>
            </div>
          </div>
          <div
            className="navBar-link"
            onClick={() => {
              removeShow();
              navigate('/fy2025-awards-and-recognition');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[3].classList.add('active');
              document.getElementsByClassName('underline')[3].classList.add('active');
            }}
            onTouchStart={() =>
              document.getElementsByClassName('underline')[3].classList.add('touchActive')
            }
            onTouchEnd={() =>
              document.getElementsByClassName('underline')[3].classList.remove('touchActive')
            }
          >
            <div className="navBar-link-inner">
              <span className="underline">Awards <br/>and recognitions</span>
            </div>
          </div>
          <div
            className="navBar-link"
            onClick={() => {
              removeShow();
              navigate('/our-approach');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[4].classList.add('active');
              document.getElementsByClassName('underline')[4].classList.add('active');
            }}
            onTouchStart={() =>
              document.getElementsByClassName('underline')[4].classList.add('touchActive')
            }
            onTouchEnd={() =>
              document.getElementsByClassName('underline')[4].classList.remove('touchActive')
            }
          >
            <div className="navBar-link-inner">
              <span className="underline">Our approach</span>
            </div>
          </div>
          <div
            className="navBar-link"
            onClick={() => {
              removeShow();
              navigate('/environment');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});

               for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[5].classList.add('active');
              document.getElementsByClassName('underline')[5].classList.add('active');
            }}
            onTouchStart={() =>
              document.getElementsByClassName('underline')[5].classList.add('touchActive')
            }
            onTouchEnd={() =>
              document.getElementsByClassName('underline')[5].classList.remove('touchActive')
            }
          >
            <div className="navBar-link-inner">
              <span className="underline">Environment</span>
            </div>
          </div>
          <div
            className="navBar-link"
            onClick={() => {
              removeShow();
              navigate('/social');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[6].classList.add('active');
              document.getElementsByClassName('underline')[6].classList.add('active');
            }}
            onTouchStart={() =>
              document.getElementsByClassName('underline')[6].classList.add('touchActive')
            }
            onTouchEnd={() =>
              document.getElementsByClassName('underline')[6].classList.remove('touchActive')
            }
          >
            <div className="navBar-link-inner">
              <span className="underline">Social</span>
            </div>
          </div>
          <div
            className="navBar-link"
            onClick={() => {
              removeShow();
              navigate('/governance');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[7].classList.add('active');
              document.getElementsByClassName('underline')[7].classList.add('active');
            }}
            onTouchStart={() =>
              document.getElementsByClassName('underline')[7].classList.add('touchActive')
            }
            onTouchEnd={() =>
              document.getElementsByClassName('underline')[7].classList.remove('touchActive')
            }
          >
            <div className="navBar-link-inner">
              <span className="underline">Governance</span>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
